import { render, staticRenderFns } from "./buildingsIcon.vue?vue&type=template&id=faee1204&"
import script from "./buildingsIcon.vue?vue&type=script&lang=js&"
export * from "./buildingsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports